import { useCallback, useEffect, useState } from 'react';
import { loggingService, LogLevel, LogEntry } from '../services/LoggingService';

export const useLogging = (moduleOrChannel?: string) => {
  const [config, setConfig] = useState(loggingService.getCurrentConfig());

  useEffect(() => {
    // Update config when it changes
    const updateConfig = () => {
      setConfig(loggingService.getCurrentConfig());
    };

    // Listen for configuration updates
    const interval = setInterval(updateConfig, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const log = useCallback((entry: Omit<LogEntry, 'moduleOrChannel'>) => {
    loggingService.log({
      ...entry,
      moduleOrChannel: moduleOrChannel || 'component'
    });
  }, [moduleOrChannel]);

  const debug = useCallback((message: string, context?: unknown) => {
    loggingService.debug(message, context, moduleOrChannel);
  }, [moduleOrChannel]);

  const info = useCallback((message: string, context?: unknown) => {
    loggingService.info(message, context, moduleOrChannel);
  }, [moduleOrChannel]);

  const warn = useCallback((message: string, context?: unknown) => {
    loggingService.warn(message, context, moduleOrChannel);
  }, [moduleOrChannel]);

  const error = useCallback((message: string, context?: unknown) => {
    loggingService.error(message, context, moduleOrChannel);
  }, [moduleOrChannel]);

  return {
    log,
    debug,
    info,
    warn,
    error,
    config,
    isEnabled: config.config?.enabled ?? false,
    level: config.config?.globalLevel ?? 'INFO'
  };
};